import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import { useStore } from "../context/StoreContext";
import Coin from "../components/Coin";

const funPhrases = [
  "You went on a big shopping adventure!",
  "The wallet went WHOOSH!",
  "A day full of joy and giggles!",
  "You picked the very best things!",
  "Legendary haul unlocked!",
];

const Orders = () => {
  const { orders, name } = useStore();

  return (
    <div className="mx-auto max-w-4xl px-4 sm:px-6 py-6 sm:py-8" data-testid="orders-page">
      <Link
        to="/shop"
        className="btn-3d btn-sm btn-ghost mb-4"
        data-testid="orders-back-btn"
      >
        <ArrowLeft size={18} strokeWidth={3} /> Back
      </Link>
      <h1 className="font-display text-3xl sm:text-4xl mb-5">
        <span className="wiggle inline-block mr-2">📜</span>
        {name || "Your"}'s Past Adventures
      </h1>

      {orders.length === 0 ? (
        <div className="chunky-card p-10 text-center" data-testid="orders-empty">
          <div className="text-7xl mb-4 bob">🗺️</div>
          <h2 className="font-display text-2xl mb-2">No adventures yet</h2>
          <p className="text-lg mb-5" style={{ color: "#484848" }}>
            Every checkout writes a new chapter here.
          </p>
          <Link to="/shop" className="btn-3d" data-testid="orders-shop-btn">
            Start your first quest
          </Link>
        </div>
      ) : (
        <ul className="flex flex-col gap-5">
          {orders.map((o, i) => (
            <li
              key={o.id}
              className="chunky-card p-5"
              data-testid={`order-item-${o.id}`}
            >
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div>
                  <div
                    className="inline-flex items-center gap-2 rounded-full px-3 py-1 mb-2"
                    style={{
                      background: "#FFB400",
                      border: "3px solid #2b2b2b",
                      color: "#2b2b2b",
                      boxShadow: "0 3px 0 #2b2b2b",
                    }}
                  >
                    <Sparkles size={14} strokeWidth={3} />
                    <span className="font-display text-sm">
                      Adventure #{orders.length - i}
                    </span>
                  </div>
                  <h3 className="font-display text-xl">
                    {funPhrases[i % funPhrases.length]}
                  </h3>
                  <div className="text-sm" style={{ color: "#484848" }}>
                    {new Date(o.date).toLocaleString()}
                  </div>
                </div>
                <div className="coin-pill" data-testid={`order-total-${o.id}`}>
                  <Coin size={18} />
                  {o.total} spent
                </div>
              </div>
              <ul
                className="mt-3 grid grid-cols-2 sm:grid-cols-3 gap-2"
                data-testid={`order-items-${o.id}`}
              >
                {o.items.map((it) => (
                  <li
                    key={it.id}
                    className="flex items-center gap-2 p-2 rounded-xl"
                    style={{
                      background: "#FFF9E6",
                      border: "2px solid #2b2b2b",
                    }}
                  >
                    <span className="text-2xl" aria-hidden="true">{it.emoji}</span>
                    <span className="text-sm">
                      <strong>{it.name}</strong>
                      <br />× {it.qty}
                    </span>
                  </li>
                ))}
              </ul>
              <div
                className="mt-3 text-sm inline-flex items-center gap-1"
                style={{ color: "#00A699" }}
              >
                Coins remaining after: <Coin size={14} /> {o.coinsAfter}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Orders;
